<template>
    <transition name="slide-fade">
        <div class="alert" :class="`alert-${response.status}`" v-if="!_.isEmpty(response.message) || !_.isEmpty(response.list)">
            <div class="text-lg font-bold" v-if="response.message" v-html="response.message"></div>
            <div class="d-flex flex-column mt-2" v-if="response.list">
                <p class="text-base mb-0" v-for="(message, key) in response.list" :key="key" v-html="message[0]"></p>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            response: {
                status: null,
                message: '',
                list: null
            },
        }
    },

    mounted() {
        let responseTimer

        Bus.$on('onSuccess', (response) => {
            clearTimeout(responseTimer)

            this.handleSuccess(response)

            responseTimer = setTimeout(() => {
                this.resetResponse()
            }, 5000)
        })

        Bus.$on('onFailure', (response) => {
            clearTimeout(responseTimer)

            this.handleErrors(response)

            responseTimer = setTimeout(() => {
                this.resetResponse()
            }, 5000)
        })
    },

    methods: {
        handleErrors(response) {
            this.resetResponse()

            this.response.status = 'danger'

            if (!_.isEmpty(response)) {
                if (
                  _.has(response, 'message') &&
                  response.message != 'The given data was invalid.'
                ) {
                    this.response.message = response.message
                }

                if (_.has(response, 'errors')) {
                    this.response.list = response.errors
                }
            } else {
                this.response.message = 'Dogodila se neočekivana greška!'
            }
        },

        handleSuccess(response) {
            this.resetResponse()

            if (!_.isEmpty(response)) {
                this.response.status = 'success'

                if (_.has(response, 'message')) {
                    this.response.message = response.message
                }
            }
        },

        resetResponse() {
            this.response = {
                status: null,
                message: '',
                list: null
            }
        },
    }
}
</script>
